import { handleDramaturgyTypeByFormat } from "../../shared/utils/handleDramaturgyTypeByFormat";

function getAdendoChapterValue(chapter) {
  if (typeof chapter === "object" && chapter !== null) {
    return chapter.number ?? chapter.chapterNumber ?? chapter.value;
  }

  return chapter;
}

function formatChapterLabel(chapter) {
  const value = getAdendoChapterValue(chapter);
  const numericValue = Number(value);

  if (Number.isFinite(numericValue)) {
    return String(numericValue).padStart(2, "0");
  }

  if (value === null || value === undefined) {
    return "";
  }

  return String(value);
}

export function formatAttachmentTypeLabel(attachment, contentFormat) {
  const dramaturgyClassification = handleDramaturgyTypeByFormat(contentFormat);

  if (attachment.format === "Adendo") {
    const intArray = attachment.addendumChapterNumbers?.length
      ? attachment.addendumChapterNumbers
      : attachment.addendumEpisodeNumbers;

    const chapterLabels = Array.isArray(intArray)
      ? intArray.map((n) => String(Number(n)).padStart(2, "0")).filter(Boolean)
      : Array.isArray(attachment.chapters)
        ? attachment.chapters.map(formatChapterLabel).filter(Boolean)
        : [];

    const adendoPrefix =
      dramaturgyClassification === "Dramaturgia Longa" ? "Cap" : "Ep";

    return chapterLabels.length
      ? `Adendo - ${adendoPrefix} ${chapterLabels.join(", ")}`
      : attachment.format;
  }

  if (attachment.format === "Capítulo/Episódio") {
    if (dramaturgyClassification === "Dramaturgia Longa") {
      return `Bloco ${attachment.blockNumber}, Capítulo ${attachment.chapterNumber}`;
    }

    if (dramaturgyClassification === "Dramaturgia Curta") {
      return `Episódio ${attachment.episodeNumber}`;
    }
  }

  return attachment.format;
}

export function groupAttachmentsByProject(attachments) {
  return Object.values(
    attachments.reduce((acc, item) => {
      const { project, attachment, grantedBy, grantedAt, expireAt, id } = item;

      if (!acc[project.id]) {
        acc[project.id] = {
          projectId: project.id,
          projectFormat: project.format.name,
          title: project.title,
          lastSharedAt: grantedAt,
          attachments: [],
        };
      }

      acc[project.id].attachments.push({
        sharingId: id,
        name: attachment.name,
        format: formatAttachmentTypeLabel(attachment, project.format.name),
        version: attachment.version,
        blockNumber: attachment.blockNumber,
        chapterNumber: attachment.chapterNumber,
        episodeNumber: attachment.episodeNumber,
        grantedBy,
        grantedAt,
        expireAt,
      });

      if (new Date(grantedAt) > new Date(acc[project.id].lastSharedAt)) {
        acc[project.id].lastSharedAt = grantedAt;
      }

      return acc;
    }, {})
  );
}

export function orderByLastSharedAt(items) {
  return [...items].sort((a, b) => {
    const dateA = new Date(a.lastSharedAt).getTime();
    const dateB = new Date(b.lastSharedAt).getTime();
    return dateB - dateA;
  });
}
